import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Page from '@/pages/Page'
import Menu from '@/pages/Menu'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
   {
      path: '/menu',
      name: 'menu',
      component: Menu
    }, 
    {
      path: '/page',
      name: 'page',
      component: Page
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js